'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');
var TabSubNavGroup = require('./tab__subnav__group.js');
var TabSubnavUserMessage = require("./tab__subnav__user__message.js");
var TabSubnavToolOptions = require("./tab__subnav__tool__options.js");

/**
 * Creates a Submenu
 *
 * @class
 */

class TabSubNav extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__tab__subnav clearfix">
                <div class="editor__tab__subnav__title left js-editor__tab__subnav__title"></div>
				<div class="editor__tab__subnav__left left js-editor__tab__subnav__left"></div>
				<div class="editor__tab__subnav__middle js-editor__tab__subnav__middle"></div>
				<div class="editor__tab__subnav__right right js-editor__tab__subnav__right"></div>
			</div>
		`;

		super.render();
	}

    /**
     * Adds a title
     *
     * @param {String} title
     */

    addTitle(title){
        $('.js-editor__tab__subnav__title', this.$el).html(title);
    }

	/**
	 * Adds a tool to the submenu
	 *
	 * @param {String} position - either 'left', 'right' or 'middle'
     * @param {Integer} weight - higher weight = last position
	 */

	addGroup(position, weight){
		var tabsubnavgroup = new TabSubNavGroup({
			target: this._getPositionContainer(this, position),
			fields: {
				'weight': (_.isUndefined(weight) ? 0 : weight)
			}
		});

		this.sortGroups(position);

		return tabsubnavgroup;
	}

	/**
	 * Sort the groups
	 */

	sortGroups(position){
		var self = this;
		var groups = $('.js-editor__tab__subnav__group', this._getPositionContainer(this, position));

		var sortedgroup = _.sortBy(groups, function(item){
			return $(item).data('weight');
		});

		_.each(sortedgroup, function(item){
			self._getPositionContainer(self, position).append($(item));
		});

	}

    addUserMessage(message, type){
        return new TabSubnavUserMessage({
            target: $('.js-editor__tab__subnav__middle', this.$el),
            fields: {
                    'message': message,
                    'type': type
            }
        });
    }

    addToolOptions(){
        return new TabSubnavToolOptions({
            target: $('.js-editor__tab__subnav__middle', this.$el)
        });
    }

	_getPositionContainer(ref, position){
		switch(position){
			case 'left':
				return $('.js-editor__tab__subnav__left', ref.$el);
				break;
			case 'right':
				return $('.js-editor__tab__subnav__right', ref.$el);
				break;
			case 'middle':
				return $('.js-editor__tab__subnav__middle', ref.$el);
				break;
		}
	}


}
module.exports = TabSubNav;
